var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('excise-transactions',{attrs:{"listObject":"wine","objectId":_vm.wineId,"back":[{text:'Wine',to:{name:'Wine'}}],"contents":false,"vessel":"","exciseTypes":_vm.excise.wineExciseTypes(true)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }